<div class="modal-dialog-centered">
    <div class="modal-content">

        <div class="modal-header">
            <h5 class="modal-title">{{ 'label.payment-history' | transloco }}</h5>
            <button class="btn btn-danger btn-extra-small" aria-label="Close" (click)="modalRef.close()">
                <i class="tf-ion-android-close"></i>
            </button>
        </div>

        <div class="modal-body">
            <div *ngIf="paymentInfo?.length; else noData" class="d-flex flex-column gap-3">
                <div class="card w-100 shadow-sm" *ngFor="let p of paymentInfo; let i = index">
                    <div class="card-body">
                        <h6 class="card-title text-primary mb-2"># {{ p.buy_order }}</h6>
                        <p class="mb-1"><strong>{{ 'label.payment-date' | transloco }}:</strong> {{
                            toLocalFormat(p.created_at) }}</p>
                        <p class="mb-1"><strong>{{ 'label.payment-type' | transloco }}:</strong> {{
                            ('label.payment-type-' + p.payment_type) | transloco }}</p>
                        <p class="mb-0">
                            <strong>{{ 'label.amount' | transloco }}:</strong>
                            {{ p.payment_amount | currency:'CLP':'symbol':'1.0-0' }}
                        </p>

                    </div>
                </div>
            </div>
            <ng-template #noData>
                <p class="text-center text-muted">{{ 'label.no-payment-records-found' | transloco }}</p>
            </ng-template>
        </div>
    </div>
</div>